const MediaService = {
  url: `${process.env.VUE_APP_MEDIA_API_URL}`,

  uploadFiles: async ({ files, register_token, customer_id, hashNames }) => {
    const sufix = "files";
    const formData = new FormData();

    Object.keys(files).forEach((key) => {
      formData.append("files", files[key]);
    });

    formData.append("register_token", register_token);
    formData.append("customer_id", customer_id);
    formData.append("hashNames", JSON.stringify(hashNames));

    const url = `${MediaService.url}/${sufix}`;

    const response = await fetch(url, {
      method: "POST",
      body: formData,
    });

    return await response.json();
  },
};

export default MediaService;
